module.exports = __webpack_public_path__ + "img/BRCA3_TMKI67.66b9e3af.png";